import apiClient from "./apiClient";

export const apiRequest = async ({
  method = "GET",
  url,
  data = null,
  params = null,
  headers = {},
}) => {
  try {
    const response = await apiClient({
      method,
      url,
      data,
      params,
      headers,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message: error,
    };
  }
};
